import PropTypes from 'prop-types';
import React from 'react';
import GlobalFooter from 'app/common/components/global-footer';
import SettingsLeftNav from 'app/components/settings/settings-left-nav';

import '@glowforge/ui-common/stylesheets/base.less';

import BasicApp from './basic-app';
import './settings-app.less';


// Wraps the Basic App and sdds a Sub-Nav bar (not needed for all pages)
const SettingsApp = props => (
  <BasicApp {...props} className='SettingsApp'>
    <div className='content'>
      <SettingsLeftNav />
      <div className='container'>
        { props.children }
      </div>
    </div>
    <GlobalFooter {...props} />
  </BasicApp>
);

SettingsApp.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default SettingsApp;



// WEBPACK FOOTER //
// ./app/components/root-apps/settings-app.jsx